import { copy } from '../content/copy';
import { SectionLabel } from '../components/SectionLabel';

export function PainPoints() {
  const { pain } = copy;
  return (
    <section className="bg-l-paper-soft bg-math-pattern px-6 md:px-10 py-20 md:py-28">
      <div className="mx-auto max-w-[1120px]">
        <SectionLabel>ЗНАКОМО?</SectionLabel>
        <h2 className="font-display font-medium text-l-ink-deep text-[32px] md:text-[40px] leading-[1.15] tracking-[-0.02em] mb-10">
          {pain.title}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {pain.items.map((item) => (
            <div
              key={item.title}
              className="bg-l-paper rounded-xl p-7 border border-l-rule/60 shadow-ring"
            >
              <p className="font-caps text-l-marginalia italic text-sm mb-3">
                {item.who}
              </p>
              <p className="font-display text-l-ink text-xl leading-[1.35]">
                {item.title}
              </p>
            </div>
          ))}
        </div>
        <p className="mt-10 font-display italic text-l-marginalia text-lg md:text-xl max-w-[680px]">
          {pain.closing}
        </p>
      </div>
    </section>
  );
}
